import TrivestComponents from '@/components/TrivestComponents';
import { addI18nPlugin } from './i18n';
import { addVuelidatePlugin } from './vuelidate';
import { addErrorExtractorPlugin } from './vuelidate-error-extractor';
import * as VueGoogleMaps from 'vue2-google-maps';
export default function addPlugins(Vue) {
    addI18nPlugin(Vue);
    addVuelidatePlugin(Vue);
    addErrorExtractorPlugin(Vue);
    Vue.use(TrivestComponents);
    Vue.use(VueGoogleMaps, {
        load: {
            key: 'AIzaSyBrvFN-oVXnK09Src0nJmI1KsP-5DycbKY',
        },
        installComponents: true
    });
}
